import { Navigate, Outlet, useLocation } from "react-router-dom";

import { homePath } from "../auth/homePath";
import { useAuth } from "../auth/useAuth";
import { FullPageSpinner } from "../components/FullPageSpinner";
import { usePermissions } from "../hooks/usePermissions";

/**
 * Gate for authenticated routes.
 */
export function ProtectedRoute({ roles, superuserOnly, agencyOnly, permission }) {
  const { isLoading, isAuthenticated, hasRole, user } = useAuth();
  const { can } = usePermissions();
  const location = useLocation();

  if (isLoading) {
    return <FullPageSpinner label="Checking your session" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  const deniedHome = homePath(user);

  if (superuserOnly && !user?.is_superuser) {
    return <Navigate to={deniedHome} replace />;
  }

  if (agencyOnly && user?.is_superuser) {
    return <Navigate to={deniedHome} replace />;
  }

  if (roles && !hasRole(...roles)) {
    return <Navigate to={deniedHome} replace />;
  }

  if (permission && !can(permission)) {
    return <Navigate to={deniedHome} replace />;
  }

  return <Outlet />;
}
